import React from 'react';
import { DispositifBadge, codeDispositif } from '../DispositifBadge';
import { DateEffetButton } from '../dateEffet/DateEffetDialog';
import { DateEffetLotBar, useSelectionLot } from '../dateEffet/DateEffetLot';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { TabsContent } from '../ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { AlertTriangle, CheckCircle, Search, Send, Loader2, ChevronLeft, ChevronRight, FolderInput, Wrench } from 'lucide-react';

export function OverviewTab({ ctx }) {
  const { fetchList, gedLoading, getDaysBadge, getStatusBadge, handleClasserGED, handleSendReminder, isAdmin, isSuperAdmin, loading, page, searchQuery, sendingId, souscriptions, statusFilter, total, totalPages, setRectifyModal, setStatusFilter, dispositifFilter, setDispositifFilter, setPage, setSearchQuery } = ctx;
  const lot = useSelectionLot();
  const idsPage = souscriptions.map((s) => s.id || s.numero_police);
  const toutCoche = idsPage.length > 0 && idsPage.every((id) => lot.coche('rcds', id));
  return (
        <TabsContent value="overview" className="mt-4 space-y-4">
          <div className="flex gap-3 flex-wrap">
            <form onSubmit={(e) => { e.preventDefault(); setPage(1); fetchList(); }} className="flex gap-2 flex-1 min-w-[200px]">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  data-testid="rcds-search"
                  value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Rechercher par nom, SIRET, email, N° police..."
                  className="pl-10"
                />
              </div>
              <Button type="submit" variant="outline"><Search className="h-4 w-4" /></Button>
            </form>
            <Select value={statusFilter} onValueChange={(v) => { setStatusFilter(v); setPage(1); }}>
              <SelectTrigger className="w-48" data-testid="status-filter">
                <SelectValue placeholder="Filtrer par statut" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tous les statuts</SelectItem>
                <SelectItem value="active">Actives</SelectItem>
                <SelectItem value="en_attente_paiement">Att. paiement</SelectItem>
                <SelectItem value="en_cours">En cours</SelectItem>
                <SelectItem value="archivee">Archivees</SelectItem>
              </SelectContent>
            </Select>
            <Select value={dispositifFilter} onValueChange={(v) => { setDispositifFilter(v); setPage(1); }}>
              <SelectTrigger className="w-48" data-testid="dispositif-filter">
                <SelectValue placeholder="Filtrer par dispositif" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tous les dispositifs</SelectItem>
                <SelectItem value="annuel">Annuelle</SelectItem>
                <SelectItem value="nominative">Nominative</SelectItem>
                <SelectItem value="archos">ARCHOS</SelectItem>
                <SelectItem value="avenant">Avenant</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {loading ? (
            <div className="flex justify-center py-12"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>
          ) : souscriptions.length === 0 ? (
            <div className="text-center py-12 text-gray-500">Aucune adhesion trouvee</div>
          ) : (
            <div className="border rounded-lg overflow-hidden">
              {isSuperAdmin && <div className="p-2 pb-0"><DateEffetLotBar selection={lot} onDone={() => fetchList()} /></div>}
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gradient-to-r from-blue-50 to-gray-50 border-b">
                    {isSuperAdmin && <th className="w-8 pl-3"><input type="checkbox" className="h-4 w-4 accent-[#0a3d62]" checked={toutCoche} onChange={(e) => lot.toutes('rcds', idsPage, e.target.checked)} data-testid="rcds-lot-tout" /></th>}
                    <th className="text-left px-4 py-3 font-semibold text-blue-800">Entreprise</th>
                    <th className="text-left px-4 py-3 font-semibold text-blue-800">Ref. Dossier</th>
                    <th className="text-left px-4 py-3 font-semibold text-blue-800">Email</th>
                    <th className="text-center px-4 py-3 font-semibold text-blue-800">Statut</th>
                    <th className="text-center px-4 py-3 font-semibold text-blue-800">Expiration</th>
                    <th className="text-right px-4 py-3 font-semibold text-blue-800">Montant Global</th>
                    {isAdmin && <th className="text-center px-4 py-3 font-semibold text-blue-800">Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {souscriptions.map((s, idx) => (
                    <tr key={s.id || idx} className="border-b hover:bg-gray-50">
                      {isSuperAdmin && <td className="pl-3"><input type="checkbox" className="h-4 w-4 accent-[#0a3d62]" checked={lot.coche('rcds', s.id || s.numero_police)} onChange={() => lot.toggle('rcds', s.id || s.numero_police)} data-testid={`rcds-lot-check-${idx}`} /></td>}
                      <td className="px-4 py-3">
                        <p className="font-medium text-gray-900 truncate max-w-[200px]">{s.raison_sociale || 'N/A'}</p>
                        {s.siret && <p className="text-xs text-gray-400">{s.siret}</p>}
                      </td>
                      <td className="px-4 py-3">
                        <code className="text-xs bg-gray-100 px-2 py-0.5 rounded">{s.numero_police || 'N/A'}</code>
                        <div className="mt-1"><DispositifBadge code={codeDispositif(s)} testId={`rcds-dispositif-badge-${idx}`} /></div>
                      </td>
                      <td className="px-4 py-3 text-xs text-gray-500">
                        {s.email || s.membre_email || <span className="text-amber-600">Non renseigne</span>}
                      </td>
                      <td className="px-4 py-3 text-center">{getStatusBadge(s.rcds_status)}</td>
                      <td className="px-4 py-3 text-center">
                        {s.date_expiration ? (
                          <div className="flex flex-col items-center gap-1">
                            <span className="text-xs text-gray-500">{new Date(s.date_expiration).toLocaleDateString('fr-FR')}</span>
                            {getDaysBadge(s.jours_restants)}
                          </div>
                        ) : <span className="text-xs text-gray-400">-</span>}
                      </td>
                      <td className="px-4 py-3 text-right font-semibold">
                        {(() => {
                          const ht = s.tarification?.montant_ht || s.tarification?.montant_contribution_ht || s.montant_ht_contribution || 0;
                          const montantGlobal = ht > 0 ? Math.round(ht * 1.38 * 100) / 100 : (s.tarification?.montant_ttc || 0);
                          return montantGlobal.toLocaleString('fr-FR', { minimumFractionDigits: 2 });
                        })()} EUR
                      </td>
                      {isAdmin && (
                        <td className="px-4 py-3 text-center">
                          <div className="flex items-center justify-center gap-1">
                            {(s.email || s.membre_email) && s.rcds_status === 'active' && (
                              <Button
                                size="sm" variant="outline"
                                onClick={() => handleSendReminder(s.id, s.email || s.membre_email)}
                                disabled={sendingId === s.id}
                                className="h-7 text-xs"
                                data-testid={`remind-${s.id}`}
                              >
                                {sendingId === s.id ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3 mr-1" />}
                                Rappeler
                              </Button>
                            )}
                            {s.attestation_url && (
                              <Button
                                size="sm" variant="outline"
                                onClick={() => handleClasserGED(s.id || s.numero_police)}
                                disabled={gedLoading === (s.id || s.numero_police)}
                                className="h-7 text-xs border-blue-300 text-blue-700 hover:bg-blue-50"
                                data-testid={`rcds-ged-${idx}`}
                              >
                                {gedLoading === (s.id || s.numero_police) ? <Loader2 className="h-3 w-3 animate-spin" /> : <FolderInput className="h-3 w-3 mr-0.5" />}
                                GED
                              </Button>
                            )}
                            {isSuperAdmin && (
                              <Button
                                size="sm" variant="outline"
                                onClick={() => setRectifyModal({ open: true, souscription_id: s.id || s.numero_police })}
                                className="h-7 text-xs border-red-300 text-red-700 hover:bg-red-50"
                                title={
                                  (s.signature_electronique || s.signature_statut === 'signed')
                                    ? 'Rectifier un document RCDS signe (Attestation / CP / CG)'
                                    : 'Modifier les donnees / pre-rectifier avant signature'
                                }
                                data-testid={`rcds-rectify-${idx}`}
                              >
                                <Wrench className="h-3 w-3 mr-0.5" />
                                Rectifier
                              </Button>
                            )}
                            {isSuperAdmin && (
                              <DateEffetButton produit="rcds" ident={s.id || s.numero_police} compact onDone={() => fetchList()} testId={`rcds-date-effet-${idx}`} />
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex items-center justify-between">
              <p className="text-sm text-gray-500">Page {page}/{totalPages} ({total} resultats)</p>
              <div className="flex gap-2">
                <Button size="sm" variant="outline" onClick={() => setPage(p => Math.max(1, p-1))} disabled={page <= 1}><ChevronLeft className="h-4 w-4" /></Button>
                <Button size="sm" variant="outline" onClick={() => setPage(p => Math.min(totalPages, p+1))} disabled={page >= totalPages}><ChevronRight className="h-4 w-4" /></Button>
              </div>
            </div>
          )}
        </TabsContent>
  );
}

export function ExpiringTab({ ctx }) {
  const { expiring, getDaysBadge, handleSendReminder, isAdmin, sendingId } = ctx;
  return (
        <TabsContent value="expiring" className="mt-4 space-y-4">
          <Card className="border-2 border-orange-200" data-testid="expiring-card">
            <CardHeader className="bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-t-lg">
              <CardTitle className="flex items-center gap-2">
                <AlertTriangle className="h-5 w-5" />
                Adhesions RCDS expirant dans les 30 prochains jours
                <Badge className="bg-white text-slate-800/20 text-white ml-auto font-semibold">{expiring.length}</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-5">
              {expiring.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <CheckCircle className="h-12 w-12 mx-auto mb-3 text-green-400" />
                  <p className="font-medium">Aucune adhesion RCDS n'expire dans les 30 prochains jours</p>
                </div>
              ) : (
                <div className="space-y-2 max-h-96 overflow-y-auto">
                  {expiring.map((s) => {
                    const email = s.email || s.membre_email || '';
                    return (
                      <div key={s.id} className="flex items-center gap-3 p-3 bg-gray-50 hover:bg-gray-100 rounded-lg border transition-colors">
                        <div className="flex-1 min-w-0">
                          <p className="font-semibold text-gray-900 truncate">{s.raison_sociale || 'N/A'}</p>
                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-xs text-gray-500">{s.numero_police}</span>
                            {email && <span className="text-xs text-gray-400">{email}</span>}
                          </div>
                        </div>
                        <div className="text-right mr-2">
                          <p className="text-xs text-gray-500">{s.date_expiration ? new Date(s.date_expiration).toLocaleDateString('fr-FR') : '-'}</p>
                        </div>
                        {getDaysBadge(s.jours_restants)}
                        {isAdmin && (
                          <Button
                            size="sm"
                            onClick={() => handleSendReminder(s.id, email)}
                            disabled={sendingId === s.id || !email}
                            className="bg-blue-600 hover:bg-blue-700 shrink-0"
                          >
                            {sendingId === s.id ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3" />}
                            <span className="ml-1 text-xs hidden sm:inline">Rappeler</span>
                          </Button>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>
  );
}
